import { render, staticRenderFns } from "./speedchat-alert.vue?vue&type=template&id=12ccbe1a&scoped=true&lang=pug&"
import script from "./speedchat-alert.vue?vue&type=script&lang=js&"
export * from "./speedchat-alert.vue?vue&type=script&lang=js&"
import style0 from "./speedchat-alert.vue?vue&type=style&index=0&id=12ccbe1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ccbe1a",
  null
  
)

export default component.exports